import React, { Component } from "react";

export interface SectionAction {
	id: string;
	icon: string;
	accLabel?: string;
	data?: any;
	showLabel?: boolean;

	[ key: string ]: any;
}

interface Props {
	title?: string;
	actions?: SectionAction[];
	onAction?: ( actionId: string, action: SectionAction ) => void;
}

interface State {
}

class FormSubSection extends Component<Props, State> {
	render() {
		const { title, children, actions, ...otherProps } = this.props;
		return (
			<>
				<div className="row">
					<div className="col-md-12 content-section">
						<div className="content-section-title">
							<span className="section-title-span">{ title }</span>
							{ actions && <div className="edit-delete-action">
								{ actions.map( ( value, index ) =>
									<SectionAction
										action={ value }
										showLabel={ value.showLabel }
										onAction={ this.props.onAction }
										key={ index }/> ) }
							</div> }
						</div>

					</div>
				</div>
				{ children }
			</>
		);
	}
}

export default FormSubSection;

function SectionAction( props: { action: SectionAction; onAction?: ( actionId: string, action: SectionAction ) => void; showLabel?: boolean } ) {
	const { action, onAction, showLabel } = props;
	if ( showLabel ) {
		return <button
			className="btn btn-grey" data-bs-target="#buyerOTPVerification"
			data-bs-toggle="modal" onClick={ () => {
			if ( onAction )
				onAction( action.id, action );
		} }>{ action.accLabel }
		</button>;
	} else {
		return <button
			onClick={ () => {
				if ( onAction )
					onAction( action.id, action );
			} }
			aria-label={ action.accLabel }
			className="btn btn-sm"
			type="button">
			<i className={ action.icon }/>
		</button>;
	}
}
